import UltMeta, { Meta } from "./UltMeta/index";

class Type extends UltMeta {
    PRIVACY_AGREEMENT = new Meta(1, "隐私政策");
    USER_AGREEMENT = new Meta(2, "用户协议");
}

export const TYPE = new Type();
